import React, { useState, forwardRef, useEffect } from 'react'
import styled, { css } from 'styled-components'
import { small, medium } from '../../lib/media_query'
import { heartbeat } from '../../lib/animations'
import { useTranslation } from '../../lib/i18n'

const Wrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 200px;
    left: 0px;
`

const NotificationWrapper = styled.div`
    z-index: 3;
    position: absolute;
    top: 0px;
    right: ${(props) => (props.animate ? 0 : -400)}px;
    opacity: ${(props) => (props.animate ? 1 : 0)};
    transition: right 800ms ease-in-out, opacity 1000ms;

    ${small(css`
        top: 95px;
    `)};

    ${medium(css`
        margin-right: 100px;
        top: 95px;
    `)};
`

const Notification = styled.div`
    position: relative;
    width: 310px;
    height: 65px;
    opacity: 1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding-left: 22px;
    z-index: 1;
    background: rgba(0, 0, 0);
    color: white;

    img {
        position: absolute;
        right: 14px;
        z-index: 1;
        top: 50%;
        transform: translateY(-50%);
    }

    span {
        font-family: ${(props) => props.theme.fontTypes.header};
        font-weight: bold;
        font-size: 17px;
    }

    button {
        cursor: pointer;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0px;
        margin-bottom: 0px;
        font-weight: bold;
        font-size: 15px;
        width: 80px;
        color: white;
        height: 100%;
        border-left: 1px solid rgba(255, 255, 255, 0.3);

        &:active {
            outline: none;
            opacity: 0.8;
        }

        &:focus {
            outline: none;
            color: white !important;
        }

        &:hover {
            color: white !important;
        }
    }
`

const Circle = styled.span`
    border-radius: 50%;
    width: 17px;
    height: 17px;
    margin-right: 14px;
    background: ${(props) => props.theme.palette.brand.green};

    animation-name: ${heartbeat};
    animation-delay: 1s;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
`

export default forwardRef(({ onClick }, ref) => {
    const [animate, setAnimate] = useState(false)
    const { t } = useTranslation(undefined, { keyPrefix: 'home.workSmarter.notification' })

    useEffect(() => {
        ref.current = {
            animate: () => setAnimate(true)
        }
    })

    return (
        <Wrapper>
            <NotificationWrapper animate={animate}>
                <Notification className="box-shadow">
                    {animate && <Circle />}
                    <span>{t('preview')}</span>
                    <button onClick={onClick}>{t('start')}</button>
                </Notification>
            </NotificationWrapper>
        </Wrapper>
    )
})
